import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { hideDialog, showDialog } from '../../../core/actions';
import Uploads from '../../expenses/containers/Upload';
import AnalyticsReport from './AnalyticsReport';

const FinancialReport = ({ reportKey, reportName }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleUploadPAndL = () => {
    dispatch(
      showDialog('CONFIRM_DIALOG', {
        defaultModal: Uploads,
        close: () => dispatch(hideDialog()),
        className: 'enhanced-dialog padded',
        title: intl.formatMessage({ id: 'uploadCSV' }),
        showFooter: false,
      })
    );
  };

  const actions = (
    <button className="button primary" onClick={handleUploadPAndL}>
      <i className="uil uil-file-upload mr-2"></i>
      {intl.formatMessage({ id: 'uploadPAndL' })}
    </button>
  );

  return <AnalyticsReport reportKey={reportKey} reportName={reportName} actions={actions} />;
};

export default FinancialReport;
